import React, { useState } from 'react';
import { Upload } from 'components/elements/file/Upload';
import PropTypes from 'prop-types';

export const FileHandler2 = ({
  token,
  uploadUrl,
  fields,
  multiple,
  finish,
  returnFiles,
  acceptFilesType,
}) => {
  const [files, setFiles] = useState([]);

  const pushImage = image => {
    setFiles([...files, image]);
  };

  const pushImages = images => {
    setFiles([...files, ...images]);
  };

  const onUploadFinish = images => {
    if (returnFiles) {
      finish(images);
      return;
    }

    let files = [];

    for (let file of images) {
      files.push(file.result.obj);
    }

    pushImages(files);

    if (finish) {
      finish(files);
    }
  };

  return (
    <div className="text-center">
      <Upload
        fileInputName={'files'}
        multiple={multiple}
        fields={fields}
        headers={{ Authorization: token }}
        uploadUrl={uploadUrl}
        onUploadFinish={onUploadFinish}
        returnFiles={returnFiles}
        acceptFilesType={acceptFilesType}
        files={files}
        multiple={multiple}
      />
    </div>
  );
};

FileHandler2.defaultProps = {
  token: null,
  uploadUrl: null,
  fields: {},
  finish: null,
  multiple: false,
  returnFiles: false,
};

FileHandler2.propTypes = {
  token: PropTypes.string,
  uploadUrl: PropTypes.string,
  fields: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
  ),
  finish: PropTypes.func,
  multiple: PropTypes.bool,
  acceptFilesType: PropTypes.arrayOf(PropTypes.string),
  returnFiles: PropTypes.bool,
};
